export default "__VITE_ASSET__BbPKYUSG__"